<script setup>
import { computed } from "vue";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps([
  "modelValue",
  "filter",
  "type",
  "required",
  "placeholder",
  "disabled",
  "max",
  "label",
  "icon",
  "error",
  "autocomplete",
  "spellcheck",
  "autocapitalize",
  "rows",
  "cols",
]);
</script>

<template>
  <div class="flex w-full flex-col gap-1.5 normal-case">
    <label
      class="text-text-base text-body-sm font-body font-medium uppercase tracking-wider"
      v-if="label && modelValue && modelValue.length > 0"
    >
      {{ label }}
    </label>
    <div
      class="w-full h-full py-4 border-b border-text-base flex items-start gap-2"
    >
      <textarea
        :placeholder="placeholder"
        :maxlength="max"
        :required="required"
        :value="modelValue"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :spellcheck="spellcheck"
        :autocapitalize="autocapitalize"
        :rows="rows || 4"
        ref="textarea"
        @input="emit('update:modelValue', $event.target.value)"
         class="flex-1 bg-transparent outline-none border-none opacity-30 text-text-base text-body-lg font-heading font-medium uppercase placeholder:text-text-base placeholder:font-heading placeholder:font-medium placeholder:uppercase placeholder:text-body-lg resize-none w-full"
      />
    </div>
    <p class="text-error text-body-sm" v-if="error">{{ error }}</p>
  </div>
</template>
